import React from 'react';
import { Table } from 'antd';
import { ColumnGroupProps } from 'antd/lib/table/ColumnGroup';

export type { ColumnGroupProps };

const ProTableColumnGroup: React.FC<ColumnGroupProps<any>> = (props) => {
  const { children, ...resProps } = props;
  return <Table.ColumnGroup {...resProps}>{children}</Table.ColumnGroup>;
};

export default ProTableColumnGroup;
